// 轮播图管理
export default [
  {
    path: "/carouselPicture",
    meta: { title: "轮播图管理" },
    component: () => import("../views/carouselPicture/index"),
    children: [
      {
        path: "/carouselPicture/carouselPictureList",
        name: "carouselPictureList",
        meta: { title: "轮播图列表", isMenu: true },
        component: () => import("../views/carouselPicture/carouselPictureList"),
      },{
        path: "/carouselPicture/detail/addEditDetails",
        name: "addEditDetails",
        meta: { title: "新增/编辑" },
        component: () => import("../views/carouselPicture/detail/addEditDetails"),
      },
    ],
  },
]
